import { render, staticRenderFns } from "./pointsReportFilterModal.vue?vue&type=template&id=0264e37d&"
import script from "./pointsReportFilterModal.vue?vue&type=script&lang=js&"
export * from "./pointsReportFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports